import { TabContext, TabPanel } from '@mui/lab';
import { Box, styled, Tab, Tabs } from '@mui/material';
import { useEffect, useState } from 'react';
import { api } from '../../../api';
import PageHeader from '../../../components/PageHeader';
import { Gate } from '../../../schema/gate';
import EsriMap from './EsriMap';

const MapPage = () => {
  const [gates, setGates] = useState<Gate[]>([]);
  useEffect(() => {
    api.get<Gate[]>(`/gate`, { params: { limit: 1000 } }).then((res) => {
      const { data } = res;
      setGates(data);
    });
  }, []);
  return (
    <Container>
      <PageHeader text="แผนที่" />
      <Box sx={{ width: '100%', mt: 2 }}>
        {/* <TabContext value={value}>
          <Tabs
            value={value}
            onChange={handleChange}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="secondary tabs example"
          >
            <Tab value="1" label="สำนักงาน" />
            <Tab value="2" label="GSP 5,6" />
            <Tab value="3" label="GSP 1,2,3" />
            <Tab value="4" label="แผนฉุกเฉิน" />
          </Tabs>
        </TabContext> */}
        <Box sx={{ overflow: 'auto', height: 700 }}>
          <EsriMap gates={gates}/>
        </Box>
      </Box>
    </Container>
  );
};

export default MapPage;

const Container = styled('div')`
  padding: 24px;
`;
